<template>
    <div class="automation-webhook-details" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <section>
            <span class="title">{{ $t("automation.catchAllWebhooks") }}</span>
            
            <div class="url-container">
                <div class="url-label">Standart Webhook URL</div>
                <div class="url">
                    <a-input :value="getWebhookURL()" disabled />
                    <SupsisButton @click="copyWebhookURL">Kopyala</SupsisButton>
                </div>
            </div>
            
            <div class="url-container">
                <div class="url-label">Bekleme Yanıtı URL (Respond to Webhook özelliği kullanıldığında)</div>
                <div class="url">
                    <a-input :value="getWebhookURLWithWaiting()" disabled />
                    <SupsisButton @click="copyResponseURL">Kopyala</SupsisButton>
                </div>
                <div class="url-description">
                    <i>Not: Eğer otomasyon içinde "Respond to Webhook" bloğu kullanıyorsanız, bu URL'yi kullanmalısınız.</i>
                </div>
            </div>
        </section>
        <a-divider />
        <section>
            <span class="title">{{ $t("automation.webhookDataExPreview") }}</span>

            <vue-json-pretty :data="getWebhookData()" />
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import { BlockStyles } from "../../../BlockConfiguration";
import BlockIconPreview from "../common/BlockIconPreview";
import RRuleGenerator from "../../../../Integrations/Ticimax/detail/automation/RRuleGenerator.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import { AUTOMATION_API } from "../../../../../../api/automation";
import { copyText2Clipboard } from "../../../../../../utils/utils";
import _ from "lodash";

import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import CONFIG from "../../../../../../config/config";

const log = log2("AutomationWebhookDetails");
export default {
    name: "AutomationWebhookDetails",
    components: { VueJsonPretty, SupsisButton, RRuleGenerator, BlockIconPreview },
    props: ["automation"],
    data() {
        return {
            animationObject: { classes: "fadeInDown", delay: 0, duration: 300 },
            animationInfinite: {
                classes: "fadeIn",
                duration: 5000,
                iteration: "infinite",
            },
            copyText2Clipboard,
            cloneAutomation: _.cloneDeep(this.automation),
        };
    },
    methods: {
        getWebhookData() {
            return _.get(this.cloneAutomation, "options.webhook.example", {
                method: "POST",
                query: "",
                body: {},
                headers: {},
            });
        },
        fetchAutomation() {
            AUTOMATION_API.findAutomationById(this.automation._id).then((automation) => {
                this.cloneAutomation = _.cloneDeep(automation);
            });
        },
        copyWebhookURL() {
            this.copyText2Clipboard(this.getWebhookURL());
            this.$message.success(this.$t("automation.webhookUrlCopied"));
        },
        copyResponseURL() {
            this.copyText2Clipboard(this.getWebhookURLWithWaiting());
            this.$message.success(this.$t("automation.webhookUrlCopied"));
        },
        isChanged() {
            return false;
        },
        getWebhookURL() {
            return `${CONFIG.SOCKET_URL}/webhook/automation/${this.automation.siteId}/${this.automation.options.webhook.id}`;
        },
        getWebhookURLWithWaiting() {
            return `${CONFIG.SOCKET_URL}/webhook/automation/${this.automation.siteId}/${this.automation.options.webhook.id}/wait-response`;
        },
        highlighter(code) {
            return Prism.highlight(code, Prism.languages.javascript, "javascript");
        },
        jsonFormat() {
            try {
                return this.getWebhookData();
            } catch (e) {
                return this.getWebhookData();
            }
        },
    },
    mounted() {
        this.fetchAutomation();
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
.automation-webhook-details {
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    padding: 25px;
    border-radius: 6px;
    height: calc(100vh - 100px);
    overflow: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .close-x {
        display: flex;
        flex-direction: row;
        justify-content: end;
    }

    section {
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding: 30px;
        background: #f7f7f7;
        border-radius: 6px;

        .title {
            font-size: 24px;
            font-weight: 700;
            color: var(--color-text-default);
            margin-bottom: 10px;
        }

        .url-container {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
            
            .url-label {
                font-weight: 600;
                margin-bottom: 8px;
                color: #555;
                font-size: 16px;
            }
            
            .url-description {
                margin-top: 6px;
                font-size: 14px;
                color: #666;
            }
        }

        .url {
            display: flex;
            gap: 10px;
            align-items: center;
            width: 100%;

            a-input {
                flex: 1;
            }
            
            button {
                min-width: 80px;
                white-space: nowrap;
            }
        }

        .my-editor {
            background: #f7f7f7;
            color: #ccc;
            font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
            font-size: 14px;
            line-height: 1.5;
            padding: 5px;
            max-height: 300px;
            overflow: scroll;
        }
    }
}
</style>
